import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ReservaEstadosEnum } from '@appNeo/core/helpers/enums/reservaEstadosEnum';
import { TiposEventosEnum } from '@appNeo/core/helpers/enums/tiposEventosEnum';
import { TiposMenuEnum } from '@appNeo/core/helpers/enums/tiposMenuEnum';
import { IMenu } from '@appNeo/core/interfaces/IMenu';
import { IMetodoPago } from '@appNeo/core/interfaces/IMetodoPago';
import { IPaquete } from '@appNeo/core/interfaces/IPaquete';
import { IReserva } from '@appNeo/core/interfaces/IReserva';
import { StorageTipo } from '@appNeo/neoCore/helpers/enums/storage-tipo.enum';
import { BYPASS_FRONT_ANONIMO_TOKEN, BYPASS_FRONT_TOKEN, BYPASS_SIN_TOKEN } from '@appNeo/neoCore/interceptors/jwt/jwt.interceptor';
import { LOADER_TRANSPARENT } from '@appNeo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { AuthService } from '@appNeo/neoCore/services/auth/auth.service';
import { StorageService } from '@appNeo/neoCore/services/storage/storage.service';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';
import { format, isValid } from 'date-fns';
import { catchError, forkJoin, map, Observable, of, Subject, tap, throwError } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

export enum estadoReservaEnum {
  borrador = '1',
  pendiente = '2',
  reservado = '3',
  cancelado = '4',
  finalizado = '5'
}

@Injectable({
  providedIn: 'root'
})
export class ReservaService {
  // solución para contextualizar endpoint area cliente y envio uso token front
  contextFront = { context: new HttpContext().set(BYPASS_FRONT_TOKEN, true) };
  contextFrontAnonimo = { context: new HttpContext().set(BYPASS_FRONT_ANONIMO_TOKEN, true) };
  contextSinToken = { context: new HttpContext().set(BYPASS_SIN_TOKEN, true) };
  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };

  public editando$ = new BehaviorSubject<boolean>(false);
  public grabando$ = new BehaviorSubject<boolean>(false);

  url = environment.api_base_url_backoffice;
  urlEntidad = this.url + '/reserva';
  urlMetodosPago = this.url + '/metodosPago';

  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();
  public entidad$: BehaviorSubject<IReserva> = new BehaviorSubject<IReserva>(null);
  public entidades$: BehaviorSubject<IReserva[]> = new BehaviorSubject<IReserva[]>(null);
  public total$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  public idTipoEvento$: BehaviorSubject<TiposEventosEnum> = new BehaviorSubject<TiposEventosEnum>(null);
  public paquete$: BehaviorSubject<IPaquete> = new BehaviorSubject<IPaquete>({ id: '', nombre: '' });


  public intentoPagoFallido$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public metodoPago$: BehaviorSubject<IMetodoPago> = new BehaviorSubject<IMetodoPago>(null);
  public importeFianza$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public metodosPago$: BehaviorSubject<IMetodoPago[]> = new BehaviorSubject<IMetodoPago[]>([]);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    private storage: StorageService,
    private authService: AuthService,
    private router: Router

  ) {
    // if (environment.debug) {
    //   console.log('');
    // }
    // let userFront = JSON.parse(this.storage.get('userFront', StorageTipo.LocalStorage));
    // this.obtenerReservaToken();
    // let reserva = userFront?.reserva;
    // this.entidad$ = new BehaviorSubject<IReserva>(reserva);
  }

  set entidad(entidad: IReserva) {
    if (entidad) {
      // this.entidad$.next(entidad);
      this.entidad$.next(this.mapearEntidad(entidad));
    }
  }

  set grabando(grabando: boolean) {
    this.grabando$.next(grabando);
  }

  set intentoPagoFallido(error: boolean) {
    this.intentoPagoFallido$.next(error);
  }

  set editando(editando: boolean) {
    this.editando$.next(editando);
  }

  get(codigo: string): Observable<IReserva>{
    return this.http.get(`${this.urlEntidad}/${codigo}`).pipe(
      map(  (data: IRespApi) =>  data['data'] ),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetReserva');
      })
    );
  }

  set idTipoEvento(idTipoEvento: TiposEventosEnum) {
    // console.log('Establecesmo idTipoEvento ', idTipoEvento);
    if (idTipoEvento) {
      this.idTipoEvento$.next(idTipoEvento);
    }
  }

  set paquete(paquete: IPaquete) {
    if (paquete) {
      this.paquete$.next(paquete);
    }
  }

  esPagoCorrecto() {
    return this.entidad$.value?.idTpvComercio != null && (this.entidad$.value?.estadoActual.id != ReservaEstadosEnum.Borrador && this.entidad$.value.estadoActual?.id != ReservaEstadosEnum.Pendiente);
  }

  gestionarExtrasOpcionales() {
    if (this.entidad$.value?.idExtrasOpcionales != '' && this.entidad$.value.idExtrasOpcionales != undefined) {
      // console.log('Grabacion extras ', this.entidad$.value.idExtrasOpcionales);
      let extrasSeleccionados = this.entidad$.value.idExtrasOpcionales;
      let arrExtrasSeleccionados = extrasSeleccionados.split(',');
      let peticionExtra: object[] = [];
      if (arrExtrasSeleccionados.length > 0) {
        arrExtrasSeleccionados.map(item => {
          peticionExtra.push({
            "idExtra": item,
            "cantidad": 1,
          });
        })
        this.asignarExtras(this.entidad$.value.codigo, peticionExtra).subscribe();
      }
    }
  }

  actualizarReservaStorage(datos) {
    this.intentoPagoFallido = false;
    let datosReserva = Object.assign({}, this.entidad$.value);
    let datosActualizados = {
      ...datosReserva,
      ...datos
    };
    if (datosActualizados.tipoEvento) {
      datosActualizados.idTipoEvento = datosActualizados.tipoEvento.id
    }
    if (datosActualizados.paquete) {
      datosActualizados.idPaquete = datosActualizados.paquete.id
    }
    this.entidad$.next(datosActualizados);
    this.storage.set('reserva', JSON.stringify(datosActualizados), StorageTipo.LocalStorage);
    return datosActualizados;
  }

  eliminarReservaStorage() {
    this.intentoPagoFallido = false;
    this.storage.remove('reserva', StorageTipo.LocalStorage);
    this.entidad$.next(null);
  }

  esFechaValidaReservaStorage() {
    if (this.entidad$.value?.fechaEvento) {
      // console.log('FECHA EVENTO ES ', this.entidad$.value?.fechaEvento, isValid(new Date(format(this.auxiliar.convertirDateEs(this.entidad$.value?.fechaEvento), 'yyyy/MM/dd'))));
      return isValid(new Date(format(this.auxiliar.convertirDateEs(this.entidad$.value?.fechaEvento), 'yyyy/MM/dd')));
    } else {
      return false;
    }
  }

  create(request: any): Observable<any> {
    return this.http.post<IRespApi>(`${this.urlEntidad}`, request, { ...this.contextLoaderTransparent }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaFront');
      })
    );
  }

  update(codigo: string, request: any) {
    // console.log('ACTUALIZAMOS RESERVA', request);
    return this.http.patch(`${this.urlEntidad}/${codigo}`, request, { ...this.contextFront }).pipe(
      tap(data => this.actualizarReservaStorage(data['data'])),
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPatchReservaFront');
      })
    );
  }

  obtenerReservaToken(): Observable<IReserva> {
    let request = this.url + '/auth/reserva';
    return this.http.get(request, { ...this.contextFront }).pipe(
      tap((data: IRespApi) => this.entidad$.next(this.mapearEntidad(data.data))),
      map((data: IRespApi) => this.mapearEntidad(data.data)),
      catchError((err: IRespApi) => {
        if (err.codigoError == 401) {
          console.warn('Borrado reserva storage y logoutFront con redireccion index, para evitar error resolve auth/reserva');
          this.authService.logoutFront();
          this.eliminarReservaStorage();
          this.router.navigate([environment.pagina_aterrizaje]);
        }
        return this.handleError(err, 'IRequestAuthReserva');
      })
    );
  }

  mapearEntidad(entidad) {
    let item = Object.assign({}, entidad);
    item.idPaquete = (item.paquete.id) ?? item.idPaquete;
    item.idTipoTurno = (item.tipoTurno.id) ?? item.idTipoTurno;
    item.idTipoEvento = (item.tipoEvento.id) ?? item.idTipoEvento;
    item.idTarifa = (item.tarifa.id) ?? item.idTipoEvento;
    item.rangoHoraEvento = (item?.horaInicioEvento && item?.horaFinEvento) ? `${item.horaInicioEvento}-${item.horaFinEvento}` : '';
    item.fechaEventoDate = new Date(item.fechaEvento);
    item.textoExtras = '';
    item.textoExtras += item?.extras?.filter(extra => !this.esExtraObligatorio(extra.idExtra, item.paquete.extras)).map((extra, key, array) => extra.nombreExtra);
    return item;
  }

  esExtraObligatorio(idExtra, extrasPaquete) {
    let extra;
    if (extrasPaquete.length > 0) {
      extra = extrasPaquete.find(extra2 => extra2.idExtra == idExtra);
    }
    let resultado = (extra) ? extra.obligatorio : true;
    return resultado;
  }
  metodosPago(): Observable<any> {
    let request = this.urlMetodosPago;
    return this.http.get(request, { ...this.contextSinToken }).pipe(
      tap((data: IRespApi) => this.metodosPago$.next(data.data)),
      map((data: IRespApi) => data.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetMetodosPagoReserva');
      })
    );
  }

  obtenerImporteFianza(): Observable<any> {
    let request = `${this.urlEntidad}/obtenerImporteFianza`;
    return this.http.get(request, {}).pipe(
      tap((data: IRespApi) => this.importeFianza$.next(data.data.importeFianza)),
      map((data: IRespApi) => data.data.importeFianza),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetFianzaReserva');
      })
    );
  }

  pagarReservaStripe(codigo, tokenStripe) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/pagarReservaStripe/${codigo}`, { id: tokenStripe }, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaStripe');
      })
    );
  }


  establecerEstadoReservaPendiente(codigo) {
    return this.http.patch<IRespApi>(`${this.urlEntidad}/reservaEstado/${codigo}`, { idReservaEstado: ReservaEstadosEnum.Pendiente }, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaEstadoPendiente');
      })
    );
  }

  establecerEstadoReservaReservado(codigo) {
    return this.http.patch<IRespApi>(`${this.urlEntidad}/reservaEstado/${codigo}`, { idReservaEstado: ReservaEstadosEnum.Reservado }, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaEstadoReservado');
      })
    );
  }

  reservaEstados() {
    let request = `${this.urlEntidad}/reservaEstados`;
    return this.http.get(request, {}).pipe(
      map((data: IRespApi) => data.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetReservaEstados');
      })
    );
  }

  reservaEsEditableAreaCliente(): Observable<boolean> {
    return this.obtenerReservaToken().pipe(
      map((data: IReserva) => data.estadoActual.id == ReservaEstadosEnum.Reservado)
    )
  }

  invitadosReserva(codigo) {
    // console.log('Invitados reserva ');
    let request = `${this.urlEntidad}/${codigo}/invitados`;
    return this.http.get(request, { ...this.contextFront }).pipe(
      map((data: IRespApi) => data.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetInvitadosReserva');
      })
    );
  }

  guardarInvitado(codigo, peticion) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${codigo}/invitados`, peticion, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaStripe');
      })
    );
  }

  // *************************************
  // MENUS 
  // *************************************

  menusDisponibles(codigo, idTipoMenu?: TiposMenuEnum): Observable<IMenu[]> {
    return this.http.get(`${this.urlEntidad}/${codigo}/menusDisponibles?idTipoMenu=${idTipoMenu}`, { ...this.contextFront }).pipe(
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetReservaMenusDisponibles');
      })
    );
  }

  asignarMenus(codigoReserva, peticion) {
    // console.log('DEBUG TOKEN ASIGNAR MENÚS', this.contextFront);
    // console.log('DEBUG PETICIÓN ASIGNAR MENU', peticion);
    return this.http.post<IRespApi>(`${this.urlEntidad}/${codigoReserva}/asignarMenus`, peticion, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaAsignarMenu');
      })
    );
  }

  eliminarMenus(codigoReserva, peticion) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${codigoReserva}/eliminarMenus`, peticion, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaEliminarMenus');
      })
    );
  }

  // *************************************
  // ASIGNAR EXTRAS 
  // *************************************
  asignarExtras(codigoReserva, peticion) {
    // console.log('Asignar extras ', codigoReserva, peticion);
    return this.http.post<IRespApi>(`${this.urlEntidad}/${codigoReserva}/asignarExtras`, peticion, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaAsignarExtra');
      })
    );
  }

  eliminarExtras(codigoReserva) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${codigoReserva}/eliminarExtras`, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaEliminarExtras');
      })
    );
  }
  asignarExtrasMenu(codigoReserva, idMenu, peticion) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${codigoReserva}/${idMenu}/asignarExtrasMenu`, peticion, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaAsignarMenu');
      })
    );
  }

  eliminarExtrasMenu(codigoReserva, idMenu) {
    return this.http.post<IRespApi>(`${this.urlEntidad}/${codigoReserva}/${idMenu}/eliminarExtrasAdmin`, {}, { ...this.contextFront }).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostReservaEliminarMenus');
      })
    );
  }

  /************************************
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticionEntidad = {
       metodosPago: this.metodosPago().pipe(
        catchError(err => of(err))
      ), 
       importeFianza: this.obtenerImporteFianza().pipe(
        catchError(err => of(err))
      )
      }
    if (this.authService.userFront$.value) {
      peticionEntidad['reserva'] = this.obtenerReservaToken().pipe(
        catchError(err => of(err))
      );
      peticionEntidad['editableAreaCliente'] = this.reservaEsEditableAreaCliente().pipe(
        catchError(err => of(err))
      );
    }
    // const id = route.params?.id;
    // const codigo = route.params?.codigo;
    // if (id) {
    //   let peticionEntidad = this.get(id);
    //   return forkJoin([peticionEntidades, peticionEntidad]);
    // } else {
    //   return forkJoin([peticionEntidades]);
    // }
    return forkJoin(peticionEntidad);
  }

  private handleError(err: IRespApi, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    // dialog específico
    console.log('CODIGO ERROR ', err);
    if (err.codigoError === 422) {
      console.log('Este es el error 422', err.codigoError);
      err.request = idRequest;
      this.error422Api$.next(err);
    }

    // pantalla común
    let mensaje = err?.mensaje;
    if (err.codigoError === 403) {
      mensaje = `${err.mensaje}: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if (err.data) {
        if (typeof err.data === 'string') {
          avisos = err.data;
        } else {
          err.data.forEach(element => {
            if (element.id === 999) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje + avisos;
    }
    return throwError({ 'error': true, 'data': err.data, mensaje, 'codigoError': err?.codigoError });
  }
}
